import { useDelegateTemplateWorkgroupMutation, useUpdateTemplateWorkgroupMutation } from '@api/survey-templates';
import { DelegateWorkgroupModalBase } from '@features/delegation';
import { MetricGroup } from '@g17eco/types/metricGroup';
import { SurveyWorkgroup } from '@g17eco/types/workgroup';
import { SurveyTemplateMinData } from '../../types';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  template: SurveyTemplateMinData;
  metricGroups: MetricGroup[];
  delegatedWorkgroups: SurveyWorkgroup[];
  editingWorkgroup?: SurveyWorkgroup;
}

export const DelegateTemplateWorkgroupModal = ({
  isOpen,
  toggle,
  template,
  metricGroups,
  delegatedWorkgroups,
  editingWorkgroup,
}: Props) => {
  const [delegateWorkgroup, { isLoading: isDelegating }] = useDelegateTemplateWorkgroupMutation();
  const [updateTemplateWorkgroup, { isLoading: isUpdating }] = useUpdateTemplateWorkgroupMutation();

  return (
    <DelegateWorkgroupModalBase
      isOpen={isOpen}
      toggle={toggle}
      entity={template}
      metricGroups={metricGroups}
      delegatedWorkgroups={delegatedWorkgroups}
      editingWorkgroup={editingWorkgroup}
      isLoading={isDelegating || isUpdating}
      entityLabel='template'
      handlers={{
        onDelegate: async ({ workgroupIds, permission }) => {
          await delegateWorkgroup({
            templateId: template._id,
            workgroupIds,
            permission,
          }).unwrap();
        },
        onUpdate: async ({ workgroupId, permission }) => {
          await updateTemplateWorkgroup({
            templateId: template._id,
            workgroupId,
            permission,
          }).unwrap();
        },
      }}
    />
  );
};
